<div class="fx-layout-row">
    <mat-icon class="alert-icon {{ icon }}">{{ icon }}</mat-icon>

    <div class="mr-6 ml-6">
        <p
            *ngFor="let message of data.messages; first as isFirst"
            [class.mat-small]="!isFirst"
            class="pt-2"
        >
            {{ message.text }}
        </p>
    </div>
    <button mat-icon-button type="button" (click)="dismissSnackbar()">
        <mat-icon>close</mat-icon>
    </button>
</div>
